import { render } from "./ParadigmIntro.vue?vue&type=template&id=2974f6b2&ts=true"
import script from "./ParadigmIntro.vue?vue&type=script&lang=ts"
export * from "./ParadigmIntro.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__